/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Type_LocationInputs */

const en_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const fr_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieu`)
};

const de_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const it_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const ru_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расположение`)
};

const es_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const zh_cn2_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地点`)
};

const ja_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const hi_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जगह`)
};

const pt_pt2_tags_manager_type_location = /** @type {(inputs: Tags_Manager_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Tags_Manager_Type_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_type_location = /** @type {((inputs?: Tags_Manager_Type_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Type_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_type_location(inputs)
	if (locale === "de") return de_tags_manager_type_location(inputs)
	if (locale === "it") return it_tags_manager_type_location(inputs)
	if (locale === "ru") return ru_tags_manager_type_location(inputs)
	if (locale === "es") return es_tags_manager_type_location(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_type_location(inputs)
	if (locale === "ja") return ja_tags_manager_type_location(inputs)
	if (locale === "hi") return hi_tags_manager_type_location(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_type_location(inputs)
	return en_tags_manager_type_location(inputs)
});